import { WalletResponseDto } from 'src/generated-sources/openapi/wallet-service/wallet';
import { TableConfig } from 'src/app/shared/components/generic-table';
import { ThousandsMaskPipe } from '../pipes/thousands-mask.pipe';

export type WalletColumnKeys = keyof WalletResponseDto | '_icon' | '_actions';

const thousandMask = new ThousandsMaskPipe();

export const createWalletTableConfig = (): TableConfig<WalletResponseDto, WalletColumnKeys> => ({
  columns: [
    {
      id: '_icon',
      title: $localize`:@@js_type:Tipo`,
      hasCustomContent: true,
      width: '50px',
      minWidth: '50px',
      maxWidth: '50px',
    },
    {
      id: 'name',
      title: $localize`:@@js_name:Nombre`,
      hasCustomContent: true,
      width: '1fr',
      minWidth: '200px',
    },
    {
      id: 'quantityRegistries',
      title: $localize`:@@js_docsQuantity:Cantidad Documentos`,
      width: '150px',
      textAlign: 'center',
      getValue: (wallet: WalletResponseDto) =>
        thousandMask.transform(wallet.quantityRegistries?.toString() || '0'),
    },
    {
      id: '_actions',
      title: $localize`:@@actions:Acciones`,
      hasCustomContent: true,
      width: '200px',
      textAlign: 'center',
    },
  ],
  rowIdFn: (wallet: WalletResponseDto) => String(wallet.id)
});
